
import { Component } from "@angular/core";
import {  FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { Recepcion_parcial } from "src/app/models/recepcion_parcial.model";

@Component({
    selector: "page-recepcion_parcial",
    templateUrl: "./recepcion_parcial.component.html",
    providers: [FormService]
})

export class Recepcion_parcialComponent {
    public rows = [];
    public actualRow;
    public recepcion_parcial: Recepcion_parcial;
    public form;

    matcher : FormService;

    constructor(){

        this.form = new FormGroup({
            superedif: new FormControl(''),
            cambios: new FormControl('')
        })

        if(!JSON.parse(localStorage.getItem("recepcion_parcial"))){
            localStorage.setItem("recepcion_parcial", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("recepcion_parcial"));

            this.form.controls['cambios'].setValue(this.rows[0]?this.rows[0].cambios:false);
            this.form.controls['superedif'].setValue(this.rows[0]?this.rows[0].superedif:'');
        }
        this.recepcion_parcial = {superedif:'',  cambios:''};

        
    }
    add_recepcion(){
        localStorage.setItem("recepcion_parcial", JSON.stringify([]))
        this.actualRow = localStorage.getItem("recepcion_parcial");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            superedif: this.form.value.superedif,
            cambios : this.form.value.cambios
          
        })
        localStorage.setItem("recepcion_parcial", JSON.stringify(this.rows));
    }
  
    delete_recepcion(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("recepcion_parcial", JSON.stringify(this.rows));
            }
        }
    }  

}